import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Tabs,
  Tab,
  InputAdornment,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import { useParams, useNavigate } from "react-router-dom";

import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import ProfileIn from "../../assets/images/prop.jpg";
import licensesIcon from "../../assets/images/icon/licenses.svg";
import { getMethod, postMethod, putMethod } from "../../services/apiService";
import { Image } from "react-bootstrap";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import CustomerLicenseTab from "./customerLicenseTab";
import CustomerSitesDevicesTab from "./customerSitesDevicesTab";
import SortTable from "./sortTable";
import DeviceTable from "./deviceTable";
import { getUserId } from "../../helper/helper";
import license from "../../assets/images/disable.svg";
import deleteIcon from "../../assets/images/delete.svg";
import SearchIcon from "@mui/icons-material/Search";
import { clearStorageAndCookies } from "../../services/authService";
import { ToastContext, useToastContext } from "../../context/toastContext";
import { PROFILE_TYPE } from "../../helper/globalConstant";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import { getUserPriority } from "../../services/authService";
import {IconFileCertificate} from "@tabler/icons-react"
const CustomerViews = () => {
  const { setToast } = useToastContext() as ToastContext;
  const navigate = useNavigate();
  let { id, companyName, sitename } = useParams();
  const typoStyle = {
    color: "#E2E3E3",
    padding: "10px 0px",
  };

  const breadCrumb = [
    {
      label: "Home",
      path: "/customer/overview",
      onClick: () => {
        const priority = getUserPriority();
        if (
          priority === PROFILE_TYPE.SUPER_ADMIN ||
          priority === PROFILE_TYPE.DISTRIBUTOR
        ) {
          setPartnerId("");
        }
      },
    },
    {
      label: companyName,
      path: `/customer/details/${companyName}/${id}`,
    },
    {
      label: sitename,
      path: `/customer/view/${companyName}/${sitename}/${id}`,
    },
  ];

  const [activeTab, setActiveTab] = useState(0);
  const [customerData, setCustomerData] = useState<any>([]);
  const [userData, setUserData] = useState<any>([]);
  const [customerLicenseTab, setCustomerLicenseTab] = useState<any>([]);
  const [tableData, setTableData] = useState<any>([]);
  const [channelData, setChannelData] = useState<any>([]);
  const [cameraStatus, setCameraStatus] = useState<any[]>([]);
  const [cameraLocationIds, setCameraLocationIds] = useState<any[]>([]);
  const [licenseData, setLicenseData] = React.useState<any>([]);
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [open, setOpen] = useState(false);
  const [deleteModel, setDeletModel] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [searchTextForDevices, setSearchTextForDevices] = useState<string>("");
  const [filteredCustomers, setFilteredCustomers] = useState<any>([]);
  const [filteredDevices, setFilteredDevices] = useState<any>([]);
  const [edgeVersion, setEdgeVersion] = useState("-");
  const { partnerId, setPartnerId } = usePartnerIdContext();
  const [userPriority, setUserPriority] = useState();
  useEffect(() => {
    console.log("channelData", channelData);
  }, [channelData]);

  const siteId = localStorage.getItem("siteId");

  useEffect(() => {
    if (!searchText || searchText === "") {
      setFilteredCustomers([...tableData]);
    } else {
      const data = tableData.map((item: any) => ({
        ...item, // Keep all other properties intact
        data: item.data.filter((dataItem: any) =>
          getPartnerName(dataItem.licenseKey)
            .toLowerCase()
            .includes(searchText.toLowerCase()),
        ),
      }));
      setFilteredCustomers(data);
    }
  }, [searchText, tableData]);

  const fetchUserPriority = async () => {
    let priority = getUserPriority();

    setUserPriority(priority);
  };

  useEffect(() => {
    fetchUserPriority();
  }, []);

  useEffect(() => {
    if (!searchTextForDevices || searchTextForDevices === "") {
      setFilteredDevices([...channelData]);
    } else {
      const filtered = channelData.filter((item: any) =>
        item?.name?.toLowerCase().includes(searchTextForDevices.toLowerCase()),
      );
      console.log("✅ Filtered results:", filtered);
      setFilteredDevices(filtered);
    }
  }, [searchTextForDevices, channelData]);

  useEffect(() => {
    fetchCustomerViewData();
    fetchCustomerList();
  }, []);

  useEffect(() => {
    if (activeTab) {
      fetchLicenseTableData();
      fetchEachSiteDevicesDetails();
      fetchEachSiteDevicesStatus();
    } else {
      fetchLicense();
    }
  }, [activeTab]);

  useEffect(() => {
    if (partnerId)
      fetchAllLicense();
  }, [partnerId]);

  const handleDelete = async () => {
    setDeletModel(!deleteModel);
  };

  const handleDeleteLicense = async () => {
    const tData = tableData?.[0]?.data;
    const result = selected?.map((index) => tData[index]);

    let payload = {
      orderId: tableData?.[0]?.orderId,
      data: result?.map((i: any) => ({
        featureKey: i.featureKey,
      })),
    };
    postMethod("customer/order/deletefeature", payload).then((res) => {
      if (res?.status === 200) {
        fetchCustomerViewData();
        fetchLicenseTableData();
        setSelected([]);
        setDeletModel(false);
      } else {
        setToast(res?.data?.message, "error");
        setDeletModel(false);
      }
    });
  };

  const fetchAllLicense = async () => {
    let partnerInfo;
    const sess_user_data = localStorage.getItem("sess_user");
    if (sess_user_data != null) {
      try {
        const sess_user = JSON.parse(sess_user_data);
        const extractedProfileId = sess_user?.userProfile;
        if (extractedProfileId) {
          const priority = extractedProfileId?.priority;
          if (
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 ||
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2
          ) {
            partnerInfo = extractedProfileId?.ownerId;
          } else if (
            priority == PROFILE_TYPE.SUPER_ADMIN ||
            priority == PROFILE_TYPE.INTEGRATOR ||
            priority == PROFILE_TYPE.DISTRIBUTOR
          ) {
            partnerInfo = partnerId;
          }
        } else {
          console.error("Priority id not found in userProfile");
        }
      } catch (error) {
        console.error("Error parsing session user data:", error);
      }
    }
    const resp = await getMethod(`partner/all/license/${partnerInfo}`);
    if (resp?.status === 200) {
      setLicenseData(resp?.data?.result);
    } else {
      setToast(resp?.data?.message, "error");
      setLicenseData([]);
    }
  };

  type DataItem = {
    key: string;
    value: any;
  };

  type CountData = {
    total: number;
    available: number;
    assigned: number;
  };

  type SiteOrder = {
    orderId: string;
    orderName: string;
    siteId: string;
    partnerId: string;
    createdAt: string;
    status: string;
    data: DataItem[];
  };

  type InputItem = {
    siteOrder: SiteOrder;
    countData: CountData;
  };

  function transformData(input: InputItem[]): SiteOrder[] {
    const transformed: Record<string, SiteOrder> = {};

    input.forEach(({ siteOrder, countData }) => {
      console.log(siteOrder);
      console.log(countData);
      const { orderId, orderName, siteId, partnerId, createdAt, status, data } =
        siteOrder;

      if (!transformed[orderId]) {
        transformed[orderId] = {
          orderId,
          orderName,
          siteId,
          partnerId,
          createdAt,
          status,
          data: [],
        };
      }

      const transformedData = data.map((item) => ({
        ...item,
        total: countData?.total,
        available: countData?.available,
        assigned: countData?.assigned,
      }));

      console.log("transformedData: ", transformedData);
      // Push the modified data into transformed structure
      transformed[orderId].data.push(...transformedData);
    });

    return Object.values(transformed);
  }

  const fetchLicenseTableData = async () => {
    const getSiteID = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`customer/order/siteid/details/${getSiteID}`);
    if (resp?.status === 200) {
      setTableData(transformData(resp?.data?.result));
    } else {
      setToast(resp?.data?.message, "error");
      setTableData([]);
    }
  };

  const getPartnerName = (license: any) => {
    let name = licenseData?.find(
      (i: any, index: any) => i?.license?.key === license,
    );

    return name?.license?.data?.name;
  };

  const fetchCustomerViewData = async () => {
    const getSiteID = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`customer/site/overview/license/${getSiteID}`);
    if (resp?.status === 200) {
      setCustomerLicenseTab(resp?.data?.result?.[0]);
    } else {
      setToast(resp?.data?.message, "error");
      setCustomerLicenseTab([]);
    }
  };

  const fetchLicense = async () => {
    const getSiteID = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`customer/site/${getSiteID}`);
    if (resp?.status === 200) {
      setUserData(resp?.data?.result?.[0]);
    } else {
      setToast(resp?.data?.message, "error");
    }
  };

  const fetchCustomerList = async () => {
    const resp = await getMethod(`customer/${id}`);
    if (resp?.status === 200) {
      setCustomerData(resp?.data?.result);
    } else {
      setToast(resp?.data?.message, "error");
      setCustomerData([]);
    }
  };

  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleDisable = async () => {
    const tData = tableData?.[0]?.data;
    const result = selected?.map((index) => tData[index]);
    const payload = {
      orderId: tableData?.[0]?.orderId,
      orderRef: tableData?.[0]?.orderRef,
      data: result?.map((i: any) => ({
        featureKey: i.featureKey,
        status: i?.status === 1 ? 0 : 1,
        expiry: i.expiry,
      })),
    };

    const resp = await putMethod("customer/order", payload);
    if (resp?.status === 200) {
      fetchLicenseTableData();
      handleClose();
      setSelected([]);
    } else {
      setToast(resp?.data?.message, "error");
    }
  };

  const headCells = [
    {
      id: "feature",
      numeric: false,
      disablePadding: true,
      label: "Feature",
    },
    {
      id: "issue Date",
      numeric: true,
      disablePadding: false,
      label: "Issue Date",
    },
    {
      id: "Expiry Date",
      numeric: true,
      disablePadding: false,
      label: "Expiry Date",
    },
    {
      id: "Validity",
      numeric: true,
      disablePadding: false,
      label: "Validity",
    },
    {
      id: "Order Name",
      numeric: true,
      disablePadding: false,
      label: "Order Name",
    },
    {
      id: "Status",
      numeric: true,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "Quantity",
      numeric: true,
      disablePadding: false,
      label: "Quantity",
    },
  ];

  const headCellsDevices = [
    {
      id: "devicename",
      numeric: false,
      disablePadding: true,
      label: "Device Name",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "location",
      numeric: false,
      disablePadding: false,
      label: "Location",
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      label: "Model",
    },
    {
      id: "ip",
      numeric: false,
      disablePadding: false,
      label: "IP",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: false,
      label: "Type",
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [resetLicenseOverview, setResetLicenseOvervie] = useState(false);

  useEffect(() => {
    if (resetLicenseOverview) {
      fetchCustomerViewData();
      setResetLicenseOvervie(false);
    }
  }, [resetLicenseOverview]);

  useEffect(() => {
    if (userData) {
      getEdgeVersion();
    }
  }, [userData]);

  const getEdgeVersion = async () => {
    const siteId = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`edge/version/site/${siteId}/current`);
    if (resp?.data?.result?.[0]?.version)
      setEdgeVersion(resp?.data?.result?.[0]?.version);
  };

  //For fetching devices details of each site
  const fetchEachSiteDevicesDetails = async () => {
    const getSiteID = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`site/${getSiteID}/location/tree/partner`);
    if (resp?.data?.code === 200) {
      setChannelData(resp?.data?.result[0].channel);
    } else {
      setToast(resp?.data?.message, "error");
      setChannelData([]);
    }
  };

  const fetchEachSiteDevicesStatus = async () => {
    const getSiteID = localStorage.getItem("siteId") ?? id;
    const resp = await getMethod(`dashboard/site/${getSiteID}/status/partner`);
    if (resp?.data?.status === 200) {
      setCameraStatus(resp?.data?.result?.cameralist);
    } else {
      // setToast(resp?.data?.message, "error");
      setCameraStatus([]);
    }
  };

  // const fetchEachSiteEachCameraLocations = async () => {
  //   const getSiteID = localStorage.getItem("siteId") ?? id;
  //   const allLocationIds: number[] = [];

  //   await Promise.all(
  //     channelData?.map(async (camera: any) => {
  //       const resp = await getMethod(`site/config/${getSiteID}/channel/${camera.id}/locations`);
  //       if (resp?.data?.code === 200) {
  //         const ids = resp?.data?.result?.[0]?.locationIds ?? [];
  //         allLocationIds.push(...ids);
  //       }
  //       else {
  //         setToast(resp?.data?.message, "error");
  //         setCameraLocationIds([]);
  //       }
  //     })
  //   );
  //   setCameraLocationIds(allLocationIds);
  // };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Header title="" breadCrumb={breadCrumb} />
        <LeftSidebar />

        {/* Main Content */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: 8,
            padding: "0",
          }}
        >
          <Typography>
            <Box
              p={3}
              sx={{
                backgroundColor: "#03171F",
                color: "#ffffff",
                minHeight: "100vh",
              }}
            >
              <Box
                // p={3}
                sx={{
                  backgroundColor: "#03171F",
                  color: "#ffffff",
                  minHeight: "100vh",
                }}
              >
                {/* Summary Section */}

                <Grid
                  container
                  spacing={2}
                  mb={2}
                  sx={{
                    display: "flex",
                    flexFlow: "nowrap",
                  }}
                >
                  <Card
                    sx={{
                      backgroundColor: "#1D292E",
                      width: "80%",
                    }}
                  >
                    <Grid
                      container
                      spacing={2}
                      mb={2}
                      sx={{
                        display: "flex",
                        flexFlow: "nowrap",
                        backgroundColor: "#1D292E",
                        margin: "0",
                        padding: "25px 20px 20px 20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: "#E2E3E3",
                          fontSize: "16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gridGap: "8px",
                        }}
                      >
                        {" "}
                        {/* <img
                          src={licensesIcon}
                          alt=""
                          width={20}
                          height={20}
                        /> */}
                        <IconFileCertificate stroke={1.4} size={20} color="#0699CE"/>{" "}
                        Total Licenses
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          color: "#E2E3E3",
                          width: "33px",
                          height: "33px",
                          borderRadius: "50%",
                          fontSize: "14px",
                          fontWeight: "500",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#293236",
                          display: "flex",
                        }}
                      >
                        {customerLicenseTab?.total}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <hr
                        style={{ width: "95%", border: "1px solid #5A5F60" }}
                      />
                    </Grid>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                      }}
                    >
                      <CardContent
                        sx={{
                          backgroundColor: "#1D292E",
                          //   width: "30%",
                          display: "flex",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            padding: "0 10px",
                            paddingLeft: "10px",
                            borderRight: "1px solid #5A5F60",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#B4B7B8", fontSize: "13px" }}
                          >
                            <span className="green"></span> Active:{" "}
                            {customerLicenseTab?.active}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            padding: "0 10px",
                            borderRight: "1px solid #5A5F60",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#B4B7B8", fontSize: "13px" }}
                          >
                            <span className="green"></span> Available:{" "}
                            {customerLicenseTab?.available}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            padding: "0 10px",
                            borderRight: "1px solid #5A5F60",
                            gap: "10px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#B4B7B8", fontSize: "13px" }}
                          >
                            <span className="red"></span> Expiring:{" "}
                            {customerLicenseTab?.expiring}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            padding: "0 10px",
                            borderRight: "1px solid #5A5F60",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#B4B7B8", fontSize: "13px" }}
                          >
                            <span className="red"></span> Expired:{" "}
                            {customerLicenseTab?.expired}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            padding: "0 10px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#B4B7B8", fontSize: "13px" }}
                          >
                            <span className="yellow"></span> Suspended:{" "}
                            {customerLicenseTab?.suspended}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Box>
                  </Card>
                  <Card
                    sx={{
                      backgroundColor: "#1D292E",
                      maxWidth: "263px",
                      width: "20%",
                      display: "flex",
                    }}
                  >
                    <CardContent
                      sx={{
                        backgroundColor: "#1D292E",
                        width: "100%",
                      }}
                    >
                      {customerData?.[0]?.vCentralUsers?.map(
                        (i: any, index: any) => {
                          return (
                            <Box
                              sx={{
                                display: "inherit",
                                border: "0",
                                borderStyle: "solid",
                                borderBottomWidth: "1px ",
                                borderColor: "#5A5F60",
                                justifyContent: "space-between",
                                alignItems: "center",
                                paddingBottom: "7px",
                                marginBottom: "7px",
                                flexFlow: "wrap",
                              }}
                              key={index}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#A5A8A9",
                                  fontSize: "10px",
                                  fontWeight: "400",
                                  display: "flex",
                                  alignItems: "center",
                                  gridGap: "8px",
                                  width: "100%",
                                }}
                              >
                                Secondary Admin
                              </Typography>
                              <Box
                                sx={{
                                  color: "#E2E3E3",
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  gridGap: "8px",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: "40px",
                                    maxWidth: "20%",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center", // Center the text horizontally
                                    borderRadius: "50%",
                                    backgroundColor: "#069aca",
                                    overflow: "hidden",
                                    color: "#000000", // Text color
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                  }}
                                >
                                  {i?.name?.charAt(0)?.toUpperCase() || "?"}{" "}
                                  {/* Display the first letter or fallback to "?" */}
                                </Box>
                                <Box
                                  sx={{ width: "80%", wordWrap: "break-word" }}
                                >
                                  {i?.name}
                                  <Typography
                                    sx={{
                                      color: "#B4B7B8",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {i?.mailId}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          );
                        },
                      )}
                    </CardContent>
                  </Card>
                </Grid>

                {/*  Search Input */}

                {filteredCustomers?.length > 0 && (
                  <Grid
                    container
                    spacing={2}
                    mb={5}
                    mt={5}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      visibility: !activeTab ? "hidden" : "unset",
                    }}
                  >
                    <Grid size={{ xs: 12, md: 6 }}>
                      <TextField
                        fullWidth
                        placeholder={
                          activeTab === 2
                            ? "Search by Device Name"
                            : "Search by License Item"
                        }
                        variant="outlined"
                        className="searchBox"
                        onChange={(e) =>
                          activeTab === 2
                            ? setSearchTextForDevices(e.target.value)
                            : setSearchText(e.target.value)
                        }
                        sx={{
                          backgroundColor: "#1D292E",
                          input: { color: "#ffffff" },
                          borderRadius: "30px",
                          //   border: "1px solid #5A5F60",
                          padding: "0 5px !important",
                          height: "41px",
                          fontWeight: "normal",
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon
                                style={{ color: "#ffffff", cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {activeTab !== 2 && (
                      <Grid
                        sx={{
                          display: "flex",
                          gap: "10px",
                          color: "#17B2EB",
                          alignItems: "center",
                        }}
                      >
                        {(userPriority === PROFILE_TYPE.INTEGRATOR ||
                          userPriority ===
                            PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 ||
                          userPriority ===
                            PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) && (
                          <>
                            <Typography
                              sx={{
                                paddingRight: "10px",
                                borderRight: "1px solid #5A5F60",
                                // color:selected?.length ? "#17B2EB" :"red",
                                // opacity:'0.8'
                                opacity: selected?.length ? 1 : 0.5,
                                cursor: selected?.length
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              onClick={selected?.length ? handleOpen : () => {}}
                            >
                              <Image
                                src={license}
                                alt={"License"}
                                style={{ fill: "red" }}
                              />{" "}
                              Disable License
                            </Typography>
                            <Typography
                              sx={{
                                cursor: selected?.length
                                  ? "pointer"
                                  : "not-allowed",
                                opacity: selected?.length ? 1 : 0.5,
                              }}
                              onClick={
                                selected?.length ? handleDelete : () => {}
                              }
                            >
                              <Image src={deleteIcon} alt={"delete"} /> Delete
                            </Typography>
                          </>
                        )}
                      </Grid>
                    )}
                  </Grid>
                )}

                {/* Tab content */}

                <TabContext value={activeTab.toString()}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    sx={{
                      display: "flex",
                    }}
                    className="tabs"
                    variant="fullWidth"
                  >
                    <Tab
                      label="Site"
                      value={0}
                      sx={{
                        width: "50%",
                        textTransform: "none",
                        borderBottom:
                          activeTab === 0 || activeTab === 1 || activeTab === 2
                            ? "1px solid"
                            : "",
                      }}
                      className="tab"
                    />
                    <Tab
                      label="Devices"
                      value={2}
                      sx={{
                        width: "50%",
                        textTransform: "none",
                        borderBottom:
                          activeTab === 0 || activeTab === 1 || activeTab === 2
                            ? "1px solid"
                            : "",
                      }}
                      className="tab"
                    />
                    <Tab
                      label="Licenses"
                      value={1}
                      sx={{
                        width: "50%",
                        textTransform: "none",
                        borderBottom:
                          activeTab === 0 || activeTab === 1 || activeTab === 2
                            ? "1px solid"
                            : "",
                      }}
                      className="tab"
                    />
                  </Tabs>

                  <TabPanel value="0">
                    <Grid sx={{ display: "flex" }}>
                      <Grid sx={{ width: "50%" }}>
                        <Typography sx={typoStyle}>
                          Site / Device Name
                          <span style={{ color: "red" }}>*</span>:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.name ?? "-"}
                          </span>
                        </Typography>
                        <Typography sx={typoStyle}>
                          Edge Version:{" "}
                          <span style={{ color: "white" }}>
                            {edgeVersion ?? "-"}
                          </span>
                        </Typography>
                        {/* <Typography sx={typoStyle}>First Name: - </Typography> */}
                        <Typography sx={typoStyle}>
                          Address Line 1:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.address?.addressline1 ?? "-"}
                          </span>
                        </Typography>
                        <Typography sx={typoStyle}>
                          City:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.address?.city ?? "-"}
                          </span>{" "}
                        </Typography>
                        <Typography sx={typoStyle}>
                          Phone Number:{" "}
                          <span style={{ color: "white" }}>
                            {/* {userData?.contact?.phone?.map( */}
                            {/* (i: any, index: any) =>  */}
                            {/* <> */}
                            {userData?.contact?.phone?.number}
                            {/* // ,</> */}
                            {/* // ) ?? "-"} */}
                          </span>
                        </Typography>
                        {/* <Typography sx={typoStyle}>Reference: -</Typography> */}
                      </Grid>
                      <Grid sx={{ width: "50%" }}>
                        <Typography sx={typoStyle}>
                          Email<span style={{ color: "red" }}>*</span>:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.contact?.email?.[0]?.id}
                          </span>
                        </Typography>
                        {/* <Typography sx={typoStyle}>Last Name: - </Typography> */}
                        <Typography sx={typoStyle}>
                          Address Line 2:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.address?.addressline2 ?? "-"}
                          </span>{" "}
                        </Typography>
                        <Typography sx={typoStyle}>
                          State / Province:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.address?.state ?? "-"}
                          </span>{" "}
                        </Typography>
                        <Typography sx={typoStyle}>
                          Postal code:{" "}
                          <span style={{ color: "white" }}>
                            {userData?.address?.postalcode}
                          </span>
                        </Typography>
                        {/* <Typography sx={typoStyle}>Company Name: -</Typography> */}
                      </Grid>
                    </Grid>
                  </TabPanel>

                  <TabPanel value="2">
                    <DeviceTable
                      rowData={filteredDevices}
                      cameraStatus={cameraStatus}
                    />
                  </TabPanel>

                  <TabPanel value="1">
                    <SortTable
                      header={headCells}
                      rowData={filteredCustomers}
                      activeTab={activeTab}
                      getPartnerName={getPartnerName}
                      getTableData={fetchLicenseTableData}
                      selected={selected}
                      setSelected={setSelected}
                      setResetLicenseOvervie={setResetLicenseOvervie}
                      userPriority={userPriority}
                    />
                  </TabPanel>
                </TabContext>
              </Box>
            </Box>
          </Typography>
        </Box>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            // width: 400,
            bgcolor: "#1D292E",
            border: "2px solid #000",
            boxShadow: 24,
            borderRadius: "12px",
            pt: 2,
            px: 4,
            pb: 3,
            width: "40%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItem: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 id="child-modal-title" style={{ padding: "10px 5px" }}>
              Disable License
            </h2>
            <CloseIcon onClick={handleClose} />
          </Box>
          <hr style={{ color: "#313838" }} />
          <Box
            sx={{
              padding: "20px 0",
              display: "flex",
              gap: "10px",
              flexDirection: "column",
              color: "#B4B7B8",
            }}
          >
            <p id="child-modal-description">
              Are you sure you want to disable {selected?.length} license
              {selected?.length > 1 ? "s" : ""}?
            </p>
            <p>
              Disabled license{selected?.length > 1 ? "s" : ""} will be
              available in the customer page.
            </p>
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              onClick={handleClose}
              variant="text"
              sx={{ textTransform: "none", color: "#17B2EB" }}
            >
              Cancel{" "}
            </Button>
            <Button
              onClick={handleDisable}
              variant="contained"
              sx={{
                textTransform: "none",
                background: "#17B2EB",
                color: "#1D292E",
                borderRadius: "30px",
              }}
            >
              Disable{" "}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* deleteModel */}
      <Modal
        open={deleteModel}
        onClose={() => {
          setDeletModel(false);
        }}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            // width: 400,
            bgcolor: "#1D292E",
            border: "2px solid #000",
            boxShadow: 24,
            borderRadius: "12px",
            pt: 2,
            px: 4,
            pb: 3,
            width: "40%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItem: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 id="child-modal-title" style={{ padding: "10px 5px" }}>
              Delete Licenses
            </h2>
            <CloseIcon
              onClick={() => {
                setDeletModel(false);
              }}
            />
          </Box>
          <hr style={{ color: "#313838" }} />
          <Box
            sx={{
              padding: "20px 0",
              display: "flex",
              gap: "10px",
              flexDirection: "column",
              color: "#B4B7B8",
            }}
          >
            <p id="child-modal-description">
              Are you sure you want to delete {selected?.length} license
              {selected?.length > 1 ? "s" : ""}?
            </p>
            <p></p>
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              onClick={() => {
                setDeletModel(false);
              }}
              variant="text"
              sx={{ textTransform: "none", color: "#17B2EB" }}
            >
              Cancel{" "}
            </Button>
            <Button
              onClick={handleDeleteLicense}
              variant="contained"
              sx={{
                textTransform: "none",
                background: "#17B2EB",
                color: "#1D292E",
                borderRadius: "30px",
              }}
            >
              Ok{" "}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CustomerViews;
